export const getFirstName = userDetails => {
    if (userDetails.firstName) return userDetails.firstName;

    if (userDetails.resumeFiles.length > 0) {
        return userDetails.resumeFiles[userDetails.resumeFiles.length - 1].firstName;
    }

    return ""
}

export const getLastName = userDetails => {
    if (userDetails.lastName) return userDetails.lastName;

    if (userDetails.resumeFiles.length > 0) {
        return userDetails.resumeFiles[userDetails.resumeFiles.length - 1].lastName;
    }

    return ""
}